var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs, _path18, _defs2, _path19, _defs3, _path20, _defs4, _path21, _defs5, _path22, _defs6, _path23, _defs7, _path24, _defs8, _path25, _defs9, _path26, _defs0, _path27, _defs1, _path28, _defs10, _path29, _defs11, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowserSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 120 99"
    },
    viewBox: "0 0 120 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#e1e4e7}.st2{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x39_40",
    transform: "translate(-410 -229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(410 229)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M15.5 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M24 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M32.5 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M41 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M49.5 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M58 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M66.5 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M75 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M83.5 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M92 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M100.4 6.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2c-1 0-2-.9-2-2",
    className: "st0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M111.9 17.5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M111.9 26.6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    d: "M111.9 35.7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    d: "M111.9 44.8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    d: "M111.9 53.9c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    d: "M111.9 62.9c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2c-1.1.1-2-.9-2-2",
    className: "st0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    d: "M111.9 72c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    d: "M111.9 81.1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2",
    className: "st0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    width: 60.2,
    height: 4,
    x: 6.6,
    y: 45.3,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_1_",
    width: 60.2,
    height: 4,
    x: 6.6,
    y: 45.3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    d: "M6.6 49.4h60.2v-4.1H6.6z",
    style: {
      mask: "url(#mask-2_1_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#95a1a9"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    width: 4,
    height: 4,
    x: 11.3,
    y: 38.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_2_",
    width: 4,
    height: 4,
    x: 11.3,
    y: 38.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_1_)"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_2_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    d: "M13.3 38.2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2",
    style: {
      mask: "url(#mask-2_2_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e92851"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    width: 4,
    height: 4,
    x: 17.8,
    y: 38.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_3_",
    width: 4,
    height: 4,
    x: 17.8,
    y: 38.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_2_)"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_3_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-42",
    d: "M19.8 38.2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2",
    style: {
      mask: "url(#mask-2_3_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1be00"
    }
  }), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    width: 4,
    height: 4,
    x: 24.3,
    y: 38.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_4_",
    width: 4,
    height: 4,
    x: 24.3,
    y: 38.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_3_)"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_4_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    d: "M26.4 38.2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2c-.1-1.1.8-2 2-2",
    style: {
      mask: "url(#mask-2_4_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00ac4a"
    }
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    width: 27.9,
    height: 23.9,
    x: 16,
    y: 57.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_5_",
    width: 27.9,
    height: 23.9,
    x: 16,
    y: 57.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_4_)"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_5_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-44",
    d: "M16 81.7h27.9V57.8H16z",
    style: {
      mask: "url(#mask-2_5_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#008ef3"
    }
  }), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    width: 4,
    height: 4,
    x: 28,
    y: 61.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_6_",
    width: 4,
    height: 4,
    x: 28,
    y: 61.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_5_)"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_6_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-45",
    d: "M28 65.8h4v-4h-4z",
    style: {
      mask: "url(#mask-2_6_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0a63f3"
    }
  }), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    width: 19.9,
    height: 16,
    x: 20,
    y: 61.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_7_",
    width: 19.9,
    height: 16,
    x: 20,
    y: 61.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_6_)"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_7_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-46",
    d: "M20 61.8h4v8h12v-8h4v16H20z",
    style: {
      mask: "url(#mask-2_7_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0a63f3"
    }
  }), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    width: 29,
    height: 4,
    x: 47.9,
    y: 57.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_8_",
    width: 29,
    height: 4,
    x: 47.9,
    y: 57.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_7_)"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_8_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    d: "M47.9 61.8h29v-4h-29z",
    style: {
      mask: "url(#mask-2_8_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e1e4e7"
    }
  }), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    width: 10.4,
    height: 4,
    x: 66.5,
    y: 65.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_9_",
    width: 10.4,
    height: 4,
    x: 66.5,
    y: 65.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_8_)"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_9_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-48",
    d: "M66.5 69.8h10.4v-4H66.5z",
    style: {
      mask: "url(#mask-2_9_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e1e4e7"
    }
  }), _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_9_",
    width: 14.6,
    height: 4,
    x: 47.9,
    y: 65.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_10_",
    width: 14.6,
    height: 4,
    x: 47.9,
    y: 65.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_9_)"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_10_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-49",
    d: "M47.9 69.8h14.6v-4H47.9z",
    style: {
      mask: "url(#mask-2_10_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e1e4e7"
    }
  }), _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_10_",
    width: 14.4,
    height: 4,
    x: 62.5,
    y: 73.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_11_",
    width: 14.4,
    height: 4,
    x: 62.5,
    y: 73.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_10_)"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_11_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-50",
    d: "M62.5 77.8h14.4v-4H62.5z",
    style: {
      mask: "url(#mask-2_11_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e1e4e7"
    }
  }), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_11_",
    width: 12.1,
    height: 12.1,
    x: 107.9,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_12_",
    width: 12.1,
    height: 12.1,
    x: 107.9,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_11_)"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_12_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    d: "M113.9 8.1c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2c.1 1.1-.9 2-2 2m-6 4H120V0h-12.1z",
    style: {
      mask: "url(#mask-2_12_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#95a1a9"
    }
  }), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_12_",
    width: 120,
    height: 98.6,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_13_",
    width: 120,
    height: 98.6,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_12_)"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_13_",
    d: "M0 98.6h120V0H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    d: "M113.9 94.6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2c.1 1.1-.9 2-2 2M6 94.6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2c.1 1.1-.8 2-2 2M4 6.1C4 5 4.9 4 6 4s2 .9 2 2-.9 2-2 2c-1.1.1-2-.8-2-1.9m103.9 80.4v3.8H89V33.9l10.3-10.3v2.7h4v-9.6h-9.6v4h2.7L74.7 42.5v-2.7h-4v9.6h9.6v-4h-2.7L85 38v52.5H12.2v-3.8h-4V35.1H79v-4H8.1v-19h4V0H0v12.1h4v74.4H0v12.1h12.1v-4.2h95.7v4.2H120V86.5z",
    style: {
      mask: "url(#mask-2_13_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#95a1a9"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserSize);
export default __webpack_public_path__ + "static/media/browserSize.47a7a769a7d70e39db90b0f624fea732.svg";
export { ForwardRef as ReactComponent };